import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

/** Keep the existing filter row swipeable and expose its hidden options. */
const FilterScroller = ({ children, rowClassName = '', rowStyle, role, ariaLabel, className = '', baseRowClassName = 'filter-buttons', rowAs: Row = 'div', scrollLabel = 'filters' }) => {
    const rowRef = useRef(null);
    const [edges, setEdges] = useState({ overflow: false, left: false, right: false });

    useEffect(() => {
        const row = rowRef.current;
        if (!row) return undefined;
        const update = () => {
            const end = Math.max(0, row.scrollWidth - row.clientWidth);
            const next = { overflow: end > 2, left: row.scrollLeft > 2, right: row.scrollLeft < end - 2 };
            setEdges(previous => previous.overflow === next.overflow && previous.left === next.left && previous.right === next.right
                ? previous : next);
        };
        update();
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
        observer?.observe(row);
        Array.from(row.children).forEach(child => observer?.observe(child));
        return () => {
            row.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            observer?.disconnect();
        };
    }, [children]);

    const move = direction => rowRef.current?.scrollBy({
        left: direction * Math.max(120, rowRef.current.clientWidth * .75),
        behavior: 'smooth'
    });

    return (
        <div className={`filter-scroll ${className}`.trim()} data-overflow={edges.overflow}>
            {edges.overflow && <button type="button" className="filter-scroll-arrow" onClick={() => move(-1)}
                disabled={!edges.left} aria-label={`Scroll ${scrollLabel} left`}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>}
            <Row ref={rowRef} className={`${baseRowClassName} ${rowClassName}`.trim()} style={rowStyle}
                role={role} aria-label={ariaLabel}>
                {children}
            </Row>
            {edges.overflow && <button type="button" className="filter-scroll-arrow" onClick={() => move(1)}
                disabled={!edges.right} aria-label={`Scroll ${scrollLabel} right`}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>}
        </div>
    );
};

export default FilterScroller;
